var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm.alwaysShow || _vm.showPackingSlipButton ? _c('OmniButton', _vm._b({
    attrs: {
      "variant": _vm.variant,
      "disabled": _vm.isPackingSlipRequested
    },
    on: {
      "click": _vm.downloadPackingSlip
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [!_vm.isPackingSlipRequested ? _c('font-awesome-layers', _vm._b({}, 'font-awesome-layers', [_vm.$attrs], false), [_c('font-awesome-icon', {
          attrs: {
            "icon": "file-pdf"
          }
        }), _vm.askLabelCount || _vm.ignoreCache ? _c('font-awesome-icon', {
          staticClass: "text-info ml-2 mb-2",
          attrs: {
            "icon": "circle-plus",
            "transform": "shrink-5"
          }
        }) : _vm._e()], 1) : _c('font-awesome-icon', _vm._b({
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        }, 'font-awesome-icon', [_vm.$attrs], false))];
      },
      proxy: true
    }], null, false, 2163781995)
  }, 'OmniButton', [_vm.$props, _vm.$attrs], false), [_vm._t("default", function () {
    return [!_vm.isPackingSlipRequested ? _c('span', _vm._b({}, 'span', [_vm.$attrs], false), [_vm.askLabelCount ? [_vm.requestedLabelCount !== null ? _c('span', [_vm._v(" Download pakbon en " + _vm._s(_vm.requestedLabelCount) + " vervoerslabel" + _vm._s(_vm.requestedLabelCount > 1 ? 's' : '') + " ")]) : _vm._e()] : _c('span', _vm._b({}, 'span', [_vm.$attrs], false), [_vm._v(" Download pakbon en vervoerslabel ")])], 2) : _c('span', _vm._b({}, 'span', [_vm.$attrs], false), [_vm._v(" Download pakbon en vervoerslabel ")])];
  })], 2) : _vm._e(), _c('b-modal', {
    attrs: {
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none",
      "title": "Kies aantal labels"
    },
    on: {
      "ok": _vm.downloadPackingSlip
    },
    model: {
      value: _vm.labelCountModalVisible,
      callback: function ($$v) {
        _vm.labelCountModalVisible = $$v;
      },
      expression: "labelCountModalVisible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v("Hoeveel labels wil je downloaden?")]), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "size": "sm",
      "min": _vm.minimumLabelCount,
      "max": _vm.maximumLabelCount,
      "autofocus": ""
    },
    model: {
      value: _vm.requestLabelCount,
      callback: function ($$v) {
        _vm.requestLabelCount = $$v;
      },
      expression: "requestLabelCount"
    }
  })], 1)], 1), _vm.isAutoPrintLabelsEnabled ? _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v("Print labels")]), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.printLabels,
      callback: function ($$v) {
        _vm.printLabels = $$v;
      },
      expression: "printLabels"
    }
  })], 1)], 1) : _vm._e(), _vm.isAutoPrintPackingSlipEnabled ? _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v("Print pakbon")]), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.printLabels,
      callback: function ($$v) {
        _vm.printLabels = $$v;
      },
      expression: "printLabels"
    }
  })], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }